// dependecies import ==>
import React, { useEffect, useState } from "react";
import { ClickAwayListener } from "@material-ui/core";

// assets and scss import ==>
import "./gstDropdown.scss";
import downArrow from "../../../../../assets/down-arrow.svg";
import upArrow from "../../../../../assets/up-arrow.svg";

// constants import
import { GST_OPTIONS } from "../../Constants";
import FormInputWithHeader from "../../../../common/FormInputWithHeader";

const GSTDropdown = ({
  gstValue,
  hsnValue,
  amountWithoutGST = 0,
  hsnError,
  hsnMandatory,
  setHsnValue,
  handleGST,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  // handlers

  const onClickGstOption = (item) => {
    handleGST(item);
    setIsOpen(false);
  };

  const getCalculatedValue = () => {
    return parseFloat(((amountWithoutGST * gstValue) / 100).toFixed(2));
  };

  const onHsnValueHandler = (event) => {
    const value = event?.target.value;
    if (value.length <= 10) {
      setHsnValue(value);
    }
  };

  // display ui

  const displayGstDropdown = () => {
    return (
      <div className="gst-hsn-wrapper">
        <div className="my-schedule-gst-input-wrapper">
          <label for="discount">GST (optional)</label>
          <div
            class="input-group-prepend fee-input msgiw-inside-div"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <div className="msgi">
              <div className="msgi-value">{gstValue}%</div>
              <img src={isOpen ? upArrow : downArrow} />
            </div>
          </div>

          <div className="my-schedule-gst-dropdown-wrapper">
            {isOpen && (
              <div className="my-schedule-gst-dropdown">
                {GST_OPTIONS?.map((item) => (
                  <div
                    className="msgid-option"
                    onClick={() => {
                      onClickGstOption(item);
                    }}
                  >
                    {item}%
                  </div>
                ))}
              </div>
            )}
          </div>

          <p>GST Fees seen by Patient : ₹ {getCalculatedValue()}</p>
        </div>
        <div className="hsn-wrapper ">
          <FormInputWithHeader
            title="HSN Code"
            placeholder="HSN Code"
            errorMsg="Enter Valid HSN code"
            value={hsnValue}
            maxLimit={10}
            type="number"
            mandatory={hsnMandatory}
            isError={hsnError}
            handleOnChangeInput={onHsnValueHandler}
          ></FormInputWithHeader>
        </div>
      </div>
    );
  };
  return (
    <ClickAwayListener
      onClickAway={() => {
        setIsOpen(false);
      }}
    >
      {displayGstDropdown()}
    </ClickAwayListener>
  );
};

export default GSTDropdown;
